/**
 * WordPress dependencies
 */
export * from '@wordpress/url';
